import Spinner from "components/Spinner";
import React, { useEffect, useState } from "react";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function ImageWIthSignedUrl({
  path,
  width,
  height,
  alt,
  imgClasses,
  imgStyle,
}) {
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;
    setUrl(null); // Clear previous image immediately
    if (!path) {
      setLoading(false);
      return;
    }
    setLoading(true);
    API.post(
      "/design-request/get-image",
      { path },
      {
        headers: authHeader(),
      }
    )
      .then(({ data }) => {
        if (isMounted) {
          setUrl(data);
          setLoading(false);
        }
      })
      .catch(() => {
        if (isMounted) {
          setUrl(null);
          setLoading(false);
        }
      });
    return () => {
      isMounted = false;
    };
  }, [path]);

  return (
    <div style={{ position: "relative" }}>
      {loading && <Spinner />}
      {!url && loading && <Spinner />}
      {url ? (
        <img
          src={url}
          width={width && width}
          height={height && height}
          alt={alt && alt}
          className={`img-fluid ${imgClasses && imgClasses}`}
          style={imgStyle && imgStyle}
        />
      ) : null}
    </div>
  );
}
